
import React from 'react';

const Footer = () => {
    return (
        <div className='row'>
            <div className='container'>
                <div className='col-md-12 d-block d-sm-block d-md-none d-lg-none d-xl-none'>
                    <div className='row'>
                        <div className='col-12 text-center'>
                            <img src='/images/logo-white.svg' alt='logo' className='img-fluid brand-logo-white' />
                        </div>
                        <div className='col-12 text-center mb-mob-3'>
                            <h1 className='footer-heading mb-2'>CATALYST</h1>
                        </div>
                        <div className='col-12 text-center mb-2 mb-mob-3'>
                            <h5 className='footer-heading-2'>Catalyst Business Partners Pvt. Ltd.</h5>
                            <p className='footer-text mb-0'>Office no 28, 3rd floor, Bansilal Building,<br /> Homi Modi Street, Fort, Mumbai – 400001.</p>
                        </div>
                        <div className='col-12 text-center mb-2 mb-mob-3'>
                            <h5 className='footer-heading-2'>Contact Us</h5>
                            <p className='footer-text lt-height mb-2'>+91 79775 11425,<br /> info@cbpgroup.in</p>
                        </div>
                        <div className='col-12 text-center mb-4 mb-mob-33'>
                            <h5 className='footer-heading-2'>Join Our Social Community</h5>
                            <ul className='list-unstyled social-links d-flex justify-content-center align-items-center gap-1'>
                                <li><a href='' target='_blank' rel='noopener noreferrer'><img src='/images/youtube.svg' alt='youtube' className='img-fluid' /></a></li>
                                <li><a href='' target='_blank' rel='noopener noreferrer'><img src='/images/insta.svg' alt='instagram' className='img-fluid' /></a></li>
                                <li><a href='' target='_blank' rel='noopener noreferrer'><img src='/images/facebook.svg' alt='facebook' className='img-fluid' /></a></li>
                                <li><a href='' target='_blank' rel='noopener noreferrer'><img src='/images/linkedin.svg' alt='linkedin' className='img-fluid' /></a></li>
                            </ul>
                        </div>
                        <div className='col-12 text-center border-bottom-1'>
                            <ul className='list-unstyled tc-links d-flex justify-content-center align-items-center gap-1 mb-2'>
                                <li><a href='/terms-conditions' target='_blank' rel='noopener noreferrer'>Terms & Condition</a></li>
                                <li><a href='/privacy-policy' target='_blank' rel='noopener noreferrer'>Privacy Policy</a></li>
                                <li><a href='' target='_blank' rel='noopener noreferrer'>Cookie Policy</a></li>
                            </ul>
                        </div>
                        <div className='col-12 text-center pt-2'>
                            <p className='footer-text-2 mb-0'>© 2025 Catalyst Business Partners rights reserved. </p>
                            <p className='footer-text-2 mb-0'>Powered by Datagrid Solutions. </p>
                        </div>
                    </div>
                </div>
                <div className='col-md-12 d-none d-sm-none d-md-block d-lg-block d-xl-block'>
                    <div className='row'>
                        <div className='col-md-12 min-vh-50'>
                            <div className='d-flex justify-content-start align-items-start'>
                                <div className='col-fixed-1 pb-3 pl-0'>
                                    <div className='d-flex justify-content-start align-items-center'>
                                        <div className='ft-logo-section me-4'>
                                            <img src='/images/logo-white.svg' alt='logo' className='img-fluid brand-logo-white p-0 me-1' />
                                        </div>
                                        <div className='ft-address-section'>
                                            <h5 className='footer-heading-2'>Catalyst Business Partners Pvt. Ltd.</h5>
                                            <p className='footer-text mb-2'>Office no 28, 3rd floor, Bansilal Building,<br /> Homi Modi Street, Fort, Mumbai – 400001.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-fixed-2 pb-3 pl-65'>
                                    <div className='row'>
                                        <div className='col-12 text-start mb-3 mb-mob-3'>
                                            <h5 className='footer-heading-2'>Contact Us</h5>
                                            <p className='footer-text lt-height mb-2'>+91 79775 11425,<br /> info@cbpgroup.in</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-fixed-3 pb-3 pe-0'>
                                    <div className='row'>
                                        <div className='col-12 text-start mb-4 mb-mob-33'>
                                            <h5 className='footer-heading-2'>Join Our Social Community</h5>
                                            <ul className='list-unstyled social-links d-flex justify-content-start align-items-center gap-1'>
                                                <li><a href='https://x.com/CatalystBizPart' target='_blank' rel='noopener noreferrer'><img src='/images/twitter.svg' alt='twitter' className='img-fluid' /></a></li>
                                                <li><a href='https://www.instagram.com/cbpgroupmumbai' target='_blank' rel='noopener noreferrer'><img src='/images/insta.svg' alt='instagram' className='img-fluid' /></a></li>
                                                <li><a href='https://www.facebook.com/people/Catalyst-Business-Partners-CBP/61581067770976/' target='_blank' rel='noopener noreferrer'><img src='/images/facebook.svg' alt='facebook' className='img-fluid' /></a></li>
                                                <li><a href='https://www.linkedin.com/company/catalyst-business-partners-cbp' target='_blank' rel='noopener noreferrer'><img src='/images/linkedin.svg' alt='linkedin' className='img-fluid' /></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-12 border-top-1'>
                            <div className='row'>
                                <div className='col-6 text-start ps-0 pe-0 pt-3'>
                                    <p className='footer-text-2 mb-0'>Copyright © 2025 Catalyst Business Partners rights reserved. Powered by Datagrid Solutions.</p>
                                </div>
                                <div className='col-6 text-end ps-0 pe-0 pt-3'>
                                    <ul className='list-unstyled tc-links d-flex justify-content-end align-items-center gap-1 mb-2'>
                                        <li><a href='/terms-conditions' target='_blank' rel='noopener noreferrer'>Terms & Condition</a></li>
                                        <li><a href='/privacy-policy' target='_blank' rel='noopener noreferrer'>Privacy Policy</a></li>
                                        <li><a href='' target='_blank' rel='noopener noreferrer'>Cookie Policy</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;